export default __webpack_public_path__ + "static/media/result3.6fd97a4a.png";